interface Coordinates {
    latitude: number | null;
    longitude: number | null;
}

export function findMostCommonCoordinates(array: Coordinates[]): Coordinates | null {
    // Filter out coordinates with null values
    const validCoordinates = array.filter(coord =>
        coord.latitude !== null &&
        coord.longitude !== null &&
        typeof coord.latitude === 'number' &&
        typeof coord.longitude === 'number'
    );

    if (validCoordinates.length === 0) {
        return null;
    }

    const coordCount: { [key: string]: number } = {};
    let maxCount = 0;
    let mostCommonCoordinates: Coordinates | null = null;

    validCoordinates.forEach(coord => {
        const key = `${coord.latitude},${coord.longitude}`;
        if (!coordCount[key]) {
            coordCount[key] = 0;
        }
        coordCount[key]++;
        if (coordCount[key] > maxCount) {
            maxCount = coordCount[key];
            mostCommonCoordinates = coord;
        }
    });

    return mostCommonCoordinates;
}
